<template>
  <MetricCircle
    :value='score'
    :label='label'
    :icon='icon'
    :name='name'
    :small='small'
  />
</template>

<script>
import MetricCircle from '@/components/MetricCircle'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'
import { useSleepStore } from '@/stores/sleep'

export default {
  name: 'MetricSleepDuration',
  props: {
    dateFrom: String,
    dateTo: String,
    hideLabel: Boolean,
    hideName: Boolean,
    small: Boolean,
  },
  components: {
    MetricCircle,
  },
  data() {
    return {
      icon: 'metric_duration.png',
      name: this.hideName ? undefined : 'Duration',
    }
  },
  beforeMount() {
    // Load duration sleep score.
    this.userStore.user.getSleepDuration(this.dateFrom, this.dateTo)
  },
  methods: {
    formatDuration(t) {
      return Math.floor(t / 60) + 'h ' + Math.round(t / 60 % 1 * 60) + 'm'
    }
  },
  computed: {
    label: {
      get() {
        return this.hideLabel ? undefined : this.formatDuration(this.sleepStore.summary.duration.average)
      }
    },
    score: {
      get() {
        return parseInt((this.sleepStore.summary.duration.score * 100).toFixed(2))
      }
    },
    ...mapStores(useUserStore, useSleepStore),
  },
}
</script>